<template>
  <div>
    <h1>Error 404</h1>
    <h4>Oops! Page not found...</h4>
    <br>
    <h4>我們無法找到您要的頁面</h4>
  </div>
</template>

<script>
export default {
  name: 'ErrorComponent',
};
</script>

<style></style>
